import * as React from "react";

import { downloadReport } from "../../../services";
import TransactionHeader from "./TransactionHeader";
import AnalyticsBelt from "./AnalyticsBelt";
import ChallanTable from "../../shared/materials/Table/ChallanTable";
import {
  columnConfig,
  economicCode,
  statusCode,
  searchFields,
  analyticsBeltMetadata,
} from "../../../data/metadata/transactionMetadata";

export default function Transaction({
  params,
  updateParams,
  transactionTable,
  populateData,
  pageNo,
  analyticsInfo,
  downloadCurrent,
}) {
  return (
    <div style={{ padding: "24px 40px" }}>
      <TransactionHeader downloadReport={downloadReport} />
      <AnalyticsBelt
        analyticsInfo={analyticsInfo}
        analyticsBeltMetadata={analyticsBeltMetadata}
      />
      <ChallanTable
        columnConfig={columnConfig}
        economicCode={economicCode}
        statusCode={statusCode}
        searchFields={searchFields}
        rows={transactionTable}
        populateData={populateData}
        params={params}
        updateParams={updateParams}
        pageNo={pageNo}
        downloadCurrent={downloadCurrent}
      />
    </div>
  );
}
